var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-initial text-center pa-2 pa-md-4"},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v("Administration Dashboard")]),_c('div',{staticClass:"body-2 mb-6"},[_vm._v("Welcome, please sign in into your account")]),_vm._t("default"),_c('div',{staticClass:"overline mt-2"},[_vm._v("Firelayer - 1.0.0 Valiant")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }